import { BenefitType } from "../enums/BenefitType";
import { Relationship } from "../enums/Relationship";
import { UploadedDocument } from "../domain/UploadedDocument";
import { ConditionType } from "../enums/ConditionType";
import { GenericRelationship } from "../enums/GenericRelationship";

export type DisabilityFormValues = {
    conditionType: ConditionType,
    documents: UploadedDocument[],
}

export const defaultDisabilityFormValues = {
    benefit: BenefitType.DISABILITY,
    disability: true,
    genericRelationship: GenericRelationship.EMPLOYEE,
    relationship: Relationship.EMPLOYEE,
    medicalRelated: true,
    conditionType: '',
    documents: [{
        document: '',
        documentContent: '',
        documentType: ''
    }],
}